<template>
  <div class="container">
    <div class="row justify-content-center no-gutters main">
      <div class="col-md-7">

        <img id="logo-orisha" class="d-block"
        src="https://medias.bimedia-it.com/assets/logo_orisha_rs_blanc.svg"/>

        <div class="card card-orisha">
          <h1 class="text-center my-5 col-10 mx-auto">
            Bienvenue sur le portail clients Orisha Retail Shops,<br>
            merci de vous identifier pour continuer.
          </h1>

          <LoginForm/>

          <div class="row justify-content-center my-5 mx-auto col-11">
            <div class="col-12 col-sm-6 mb-3">
              <button type="button" class="btn btn-outline-light btn-sm btn-block bg-grey"
                      data-toggle="modal"
                      data-target="#recoverymodal" style="margin-bottom: 5px">
                Mot de passe oublié ?
              </button>
            </div>
            <div class="col-12 col-sm-6 mb-3">
              <button type="button"
                        class="btn btn-outline-light btn-sm btn-block bg-grey"
                        data-toggle="modal"
                        data-target="#registermodal">
                  Créer mon compte
              </button>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-11">
              <p class="small text-center text-muted" style="color:#383838!important;">
                {{ version }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <Modal type="recovery" modal-title="Reinitialisation de mot de passe"/>
      <Modal type="register" modal-title="Créer mon compte"/>
    </div>
  </div>
</template>

<script>
import Modal from '../components/Modal.vue';
import LoginForm from '../components/form/LoginForm.vue';

export default {
  name: 'Login',
  data() {
    return {
      // Module source
      source: this.$route.query.source,
      // Chemin de destination
      path: this.$route.query.path,
      url: this.$route.query.url,
      hash: this.$route.hash || '',
      version: process.env.VUE_APP_VERSION,
    };
  },
  methods: {
    checkSource() {
      if (!this.source && !this.url) {
        this.source = 'Portail';
      }
    },
  },
  created() {
    // eslint-disable-next-line no-console
    console.log(this.version);
    this.checkSource();
  },
  components: {
    LoginForm,
    Modal,
  },
};
</script>
